<div class="p-4">

  <h3 class="text-2xl font-semibold text-gray-900 mb-6 tracking-tight">
    Staff List
  </h3>

  <ul class="bg-white rounded-2xl shadow-lg border border-gray-100 divide-y divide-gray-100">

    <li
      *ngFor="let staff of staffList"
      class="flex items-center justify-between px-5 py-5 hover:bg-gray-50 transition cursor-pointer"
      (click)="onRowClick(staff, $event)"
    >

      <!-- LEFT: Avatar + Info -->
      <div class="flex items-center gap-4">
        <div class="relative">
          <img
            [src]="staff?.profile || '/assets/images/user/user-profile.png'"
            class="w-14 h-14 rounded-full object-cover shadow-sm border border-gray-200"
            alt="profile"
          />
        </div>

        <div class="flex flex-col">
         <span class="text-lg font-medium text-gray-900 leading-tight">
          {{ staff.name }}
        </span>
          <span class="text-lg text-gray-900 leading-tight">
          {{ staff.name }}
        </span>
        </div>
      </div>

      <!-- MIDDLE: Modern Professional Buttons -->
      <div class="flex items-center gap-3 ml-auto mr-6">

        <!-- Issue Button -->
        <button
          (click)="$event.stopPropagation(); onIssue(staff)"
          [attr.aria-label]="'Issue to ' + staff.name"
          class="px-5 py-1.5 rounded-full text-sm font-medium text-white
                 bg-gradient-to-r from-blue-500 to-blue-600
                 hover:from-blue-600 hover:to-blue-700
                 shadow-md hover:shadow-lg transition-all duration-150"
        >
          Issue
        </button>

        <!-- Assign Button -->
        <button
          (click)="$event.stopPropagation(); onAssign(staff)"
          [attr.aria-label]="'Assign to ' + staff.name"
          class="px-5 py-1.5 rounded-full text-sm font-medium text-white
                 bg-gradient-to-r from-emerald-500 to-emerald-600
                 hover:from-emerald-600 hover:to-emerald-700
                 shadow-md hover:shadow-lg transition-all duration-150"
        >
          Assign
        </button>

      </div>

      <!-- RIGHT: Minimal Chevron -->
      <div class="text-gray-300 group-hover:text-gray-500 transition">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 5l7 7-7 7" />
        </svg>
      </div>

    </li>

    <li *ngIf="staffList.length === 0" class="py-6 text-center text-gray-500">
      No staff found.
    </li>

  </ul>
</div>
